/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * Lotus Health
 * OpenAPI spec version: 0.0.0
 */

/**
 * Valid medication status types for DoseSpot.
 */
export type MedicationStatusTInput =
  (typeof MedicationStatusTInput)[keyof typeof MedicationStatusTInput];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const MedicationStatusTInput = {
  Unknown: "Unknown",
  Active: "Active",
  Inactive: "Inactive",
  Discontinued: "Discontinued",
  Deleted: "Deleted",
  Completed: "Completed",
  CancelRequested: "CancelRequested",
  CancelPending: "CancelPending",
  Cancelled: "Cancelled",
  CancelDenied: "CancelDenied",
  Changed: "Changed",
  FullFill: "FullFill",
  PartialFill: "PartialFill",
  NoFill: "NoFill",
} as const;
